import React, { useState, useEffect, useRef } from "react";
import HeaderSortNews from "../HeaderSortNews";
import TranslateText from "../TranslateText";
import { useDispatch } from "react-redux";
import "../../../assets/style/pageStyle/statistics.scss";
import LineChart from "../Chart/LineChart";
import {
  getListTitlePosts,
  getReportViewPosts,
} from "../../../services/slice/statisticsSlice";
import TableAccessPost from "../Table/TableAccessPost";
import SelectValue from "../Selector/SelectValue";
import { timeSelectReport } from "../../../utils/ValueSelect";
import { Checkbox, Select } from "antd";
import { Option } from "antd/lib/mentions";
import { useSelector } from "react-redux";
import { statisticsSelector } from "../../../services/selector/index.";
const TabAccessPost = ({ type }) => {
  const [listLabel, setListLabel] = useState({ views: [], display: [] });
  const [dataChart, setDataChart] = useState([]);
  const [listLabelChart, setListLabelChart] = useState([]);
  const statisticsState = useSelector(statisticsSelector);
  const [openSelect, setOpenSelect] = useState(false);
  const selectRef = useRef();
  const { listTitlePost, dataReportViewPosts } = statisticsState;

  const dispatch = useDispatch();
  const [config, setConfig] = useState({
    titlePostList: [],
    timeReport: 1,
    typePosts: type,
    typeField: 1,
    timeCreate: "",
    day: 0,
  });
  useEffect(() => {
    if (type) {
      setConfig({ ...config, typePosts: type });
    }
  }, [type]);
  useEffect(() => {
    if (listTitlePost?.length > 0) {
      setConfig({ ...config, titlePostList: listTitlePost.slice(0, 5) });
    }
  }, [listTitlePost?.length]);
  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setOpenSelect(false);
        }
      }

      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }
  useOutsideAlerter(selectRef);
  useEffect(() => {
    dispatch(getListTitlePosts(type));
    dispatch(getReportViewPosts({ ...config, typeField: 1 }));
    dispatch(getReportViewPosts({ ...config, typeField: 2 }));
  }, [type, dispatch, config]);
  useEffect(() => {
    dispatch(getListTitlePosts(type));
  }, [type, dispatch]);

  const toggleCheckbox = (item) => {
    const index = config.titlePostList.findIndex(
      (selectedItem) => selectedItem.id === item.id
    );
    if (index === -1) {
      if (config.titlePostList.length < 5) {
        setConfig({
          ...config,
          titlePostList: [...config.titlePostList, item],
        });
      }
    } else {
      setConfig({
        ...config,
        titlePostList: config.titlePostList.filter(
          (selectedItem) => selectedItem.id !== item.id
        ),
      });
    }
  };
  useEffect(() => {
    const labels = { views: [], display: [] };
    const dataChart = { views: [], display: [] };
    let labelChart = { views: [], display: [] };
    dataReportViewPosts?.views?.map((value, index) => {
      const result = [];
      const label = [];
      value.list.map((item) => {
        result.push(item.total);
        label.push(item.date);
      });
      labels.views.push(value.title);
      dataChart.views.push(result);
      labelChart.views = label;
    });
    dataReportViewPosts?.display?.map((value, index) => {
      const result = [];
      const label = [];
      value.list.map((item) => {
        result.push(item.total);
        label.push(item.date);
      });
      labels.display.push(value.title);
      dataChart.display.push(result);
      labelChart.display = label;
    });

    setListLabel(labels);
    setDataChart(dataChart);
    setListLabelChart(labelChart);
  }, [dataReportViewPosts?.views, dataReportViewPosts?.display]);
  const listColor = ["#FB3839", "#047DE7", "#47E021", "#F1D90C", "#000000"];
  return (
    <div className="wrapperAccessPost">
      <div className="header">
        <h2 className="title">
          <TranslateText text={"Tình hình truy cập bài viết "} />
        </h2>
        <div className="warpperSlecter">
          <div className="selecter">
            <span>Chọn bài viết</span>{" "}
            <div>
              <Select
                // value={value}
                // onChange={handleChange}
                mode="multiple"
                // onClick={() => setOpenSelect(!openSelect)}
                placeholder={"Chọn thời bài viết cần xem"}
                className={"selectGray"}
                value={"Chọn bài viết cần xem"}
              >
                {listTitlePost?.map((value, i) => {
                  return (
                    <div className="itemCheckbox">
                      <Checkbox
                        key={value.id}
                        checked={config.titlePostList.find(
                          (item) => item.id === value.id
                        )}
                        onChange={(e) => {
                          toggleCheckbox(value);
                          setOpenSelect(true);
                        }}
                        value={value.id}
                      >
                        <Option
                          value={value.title}
                          style={{
                            display: "block",
                            position: "relative",
                          }}
                        >
                          <span
                            style={{
                              width: "100%",
                              display: "flex",
                              justifyContent: "space-between",
                              paddingRight: "3rem",
                              maxWidth: "98%",
                              overflow: "hidden",
                            }}
                            className="labelSelect"
                          ></span>
                        </Option>
                        {value.title}
                      </Checkbox>
                    </div>
                  );
                })}
                ;
              </Select>
            </div>
          </div>
          <div className="selecter">
            <span>Chọn thời gian</span>{" "}
            <SelectValue
              type={"selectGray"}
              optionsValue={timeSelectReport}
              defaultValue={"7 ngày"}
              width={170}
              handleChange={(value) => {
                setConfig({ ...config, timeReport: value });
              }}
            />
          </div>
        </div>
      </div>
      <div className="chartStatistics">
        <div className="titleChart">Theo dõi số lượng xem bài viết</div>
        <LineChart
          titleToolTip="Lượt xem"
          listColor={listColor}
          labels={listLabelChart.views}
          dataIn={dataChart.views}
        />
        <div className="listLabel">
          {listLabel.views.map((item, index) => {
            return (
              <div className="labelItem">
                <span
                  className="dotLabel"
                  style={{ backgroundColor: listColor[index] }}
                ></span>
                {item}
              </div>
            );
          })}
        </div>
      </div>
      <div className="chartStatistics">
        <div className="titleChart">Theo dõi số lượng hiển thị bài viết</div>
        <LineChart
          titleToolTip="Lượt hiển thị"
          listColor={listColor}
          labels={listLabelChart.display}
          dataIn={dataChart.display}
        />
        <div className="listLabel">
          {listLabel.display.map((item, index) => {
            return (
              <div className="labelItem">
                <span
                  className="dotLabel"
                  style={{ backgroundColor: listColor[index] }}
                ></span>
                {item}
              </div>
            );
          })}
        </div>
      </div>
      <TableAccessPost type={type} setConfig={setConfig} config={config} />
    </div>
  );
};

export default TabAccessPost;
